import React from "react";

import svg from "../../assets/images/icons/Data Mapper Dark.svg";

export const MappingDarkIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Mapping"}
    />
);
